<template>
  <div>
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('reports.masterReport')"></general-top-bar> -->
    <!--End General Top Bar -->
    <div class="sales-report">
      <div class="row mar-bt-15">
        <!-- Left Column -->
        <div class="col-md-6">
          <div class="mb-3 w-100" v-if="showLocations">
            <label class="form-label text-start w-100">{{$t('dashboard.selectLocation')}}</label>
            <select class="form-control mar-bt-15" v-model="orders.location">
            <option value="" selected :label="$t('general.all')">{{$t('general.all')}}</option>
              <template v-for="loc in locations">
                <option :label="loc.name" :value="loc.id">{{loc.name}}</option>
              </template>
            </select>
          </div>

          <div class="mb-3 w-100">
            <label class="form-label text-start w-100">{{$t('reports.taxation')}}</label>
            <v-select
              v-model="hasRceipt"
              :options="receiptOptions"
              label="label"
              :reduce="method => method.key"
              :placeholder="$t('general.all')"
              class="w-100 white mar-bt-15 line-heigth-44"
              :key="'has-receipt-select'"
            />
          </div>

          <div class="mb-3 w-100">
            <label>{{$t('reports.topCategory')}}</label>
            <v-select
              v-model="topCategoryId"
              multiple
              :options="topCategories"
              label="name"
              :placeholder="$t('general.all')"
              class="mar-bt-15 line-heigth-44"
            />
          </div>

          <div class="mb-3 w-100">
            <label>{{$t('reports.section')}}</label>
            <v-select
              v-model="sectionId"
              multiple
              :options="sections"
              label="name"
              :placeholder="$t('general.all')"
              class="line-heigth-44"
            />
          </div>
        </div>

        <!-- Right Column -->
        <div class="col-md-6">
          <div class="mb-3 w-100" v-if="paymentMethods.length">
            <label class="form-label text-start w-100">{{$t('dashboard.selectedPaymentMethods')}}</label>
            <v-select
              v-model="selected_payment_methods"
              multiple
              :options="paymentMethods"
              label="name"
              :reduce="method => method.id"
              :placeholder="$t('general.all')"
              class="w-100 white mar-bt-15 line-heigth-44"
              :key="'payment-methods-multiselect'"
            />
          </div>

          <div class="mb-3 w-100 mar-bt-15">
            <label class="form-label text-start w-100">{{$t('general.orderId')}}</label>
            <input 
              type="number"
              min="0"
              name="price"
              placeholder="3823231"
              v-model="orderId"
              class="form-control">
          </div>

          <div class="mb-3 w-100" v-if="posUsers.length">
            <label class="form-label text-start w-100">{{$t('reports.operator')}}</label>
            <select class="form-control mar-bt-15" v-model="selectedPosUser">
              <option value="" selected :label="$t('general.alls')">{{$t('general.alls')}}</option>
              <template v-for="operator in posUsers">
                <option :label="operator.firstname + ' ' + operator.lastname" :value="operator.id">
                  {{operator.firstname}} {{operator.lastname}}
                </option>
              </template>
            </select>
          </div>

          <div class="mb-3 w-100">
            <label class="form-label text-start w-100">{{$t('reports.zet')}}</label>
            <input
              type="number"
              min="0"
              class="form-control mar-bt-15"
              :placeholder="$t('reports.zet')"
              v-model="zet">
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <p class="pull-left">
          <el-date-picker
            type="daterange"
            v-model="orders.valid"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :name="pickerNames"
            :picker-options="pickerOptions">
          </el-date-picker>
          <div class="pull-left" 
            style="display: flex;
              align-items: center;
              justify-content: center;
              margin-left: 10px;"
          >
            {{$t('general.from')}}
            <el-time-select
              :placeholder="$t('catalogProd.timePlaceholder')"
              :value="valid_from"
              v-model="valid_from"
              style="margin-left: 10px;"
              :change="changeValidFrom()"
              class="mar-rt-5"
              :picker-options="{
                start: '00:00',
                step: '00:10',
                end: '24:00'
              }">
            </el-time-select>
            {{$t('general.to')}}
            <el-time-select
              :placeholder="$t('catalogProd.timePlaceholder')"
              :value="valid_to"
              v-model="valid_to"
              :change="changeValidFrom()"
              class="mar-lt-5"
              :picker-options="{
                start: '00:00',
                step: '00:10',
                end: '24:00'
              }">
            </el-time-select>
          </div>
          <select
            class="form-control pull-left"
            v-model="date_column"
            style="width: auto; min-width: 140px; margin-left: 10px; height: 40px; vertical-align: middle;">
            <option value="created_at">{{$t('reports.dateColumnCreate')}}</option>
            <option value="closed_at">{{$t('reports.dateColumnClose')}}</option>
            <option value="fiscalized_at">{{$t('reports.dateColumnFiscalize')}}</option>
          </select>
          <div class="pull-left search-button-reports">
          <div :title="$t('reports.search')" class="btn btn-icon btn-info btn-search" @click="updateData"><i class="ti-search"></i></div>
          </div>
          <div class="search-button-reports form-group pull-left">
            <div :title="$t('reports.export')" class="btn btn-icon btn-xls-slim" @click="exportData()">{{$t('general.download_xls') }} <img src="/static/img/export_xls.png"></div>
          </div>
          <div class="search-button-reports form-group pull-left">
            <div :title="$t('reports.export')" class="btn btn-icon btn-xls-slim" @click="exportVatTotalsPdf()">{{$t('general.download_pdf') }} <img src="/static/img/export_xls.png"></div>
          </div>
        </p>
      </div>
      <div class="col-md-12">
        <p style="text-align:left; margin: 20px 0px;"> {{ $t('reports.interval')}}: <b>{{orders.valid[0]}} {{valid_from}}:00</b> - <b>{{orders.valid[1]}} {{valid_to}}:00</b></p>
      </div>

      <!-- Totals Section -->
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-6">
            <div class="card center-sales-report-stats" style="height: 100% !important;">
              <div class="card-content" v-loading="loading">
                <div class="report-container">
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.orderItemValueCollected')}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(totalSum || 0)}}</div>
                  </div>
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.shipping')}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(productsTableDataTotals.total_order_shipping || 0)}}</div>
                  </div>
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.tips')}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(productsTableDataTotals.total_order_tips || 0)}}</div>
                  </div>
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.totalTax')}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(productsTableDataTotals.total_order_extras || 0)}}</div>
                  </div>
                  <!-- <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.orderItemDiscount')}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(productsTableDataTotals.total_product_discount || 0)}}</div>
                  </div>
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.orderDiscount')}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(productsTableDataTotals.total_order_discount || 0)}}</div>
                  </div>
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.orderLoyaltyDiscount')}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(productsTableDataTotals.total_order_loyalty_points_discount || 0)}}</div>
                  </div> -->
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.orderItemDiscount')}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(productsTableDataTotals.total_product_discount || 0)}}</div>
                  </div>
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.orderDiscount')}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(productsTableDataTotals.total_order_discount || 0)}}</div>
                  </div>
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.orderLoyaltyDiscount')}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(productsTableDataTotals.total_order_loyalty_points_discount || 0)}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="card center-sales-report-stats" style="height: 100% !important;">
              <div class="card-content" v-loading="vatLoading">
                <div class="report-container" style="max-height: 385px; overflow-y: auto;">
                  <!-- <div class="report-row"> -->
                    <!-- <div class="report-col left-align">{{$t('reports.orderItemValueCollected')}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(totalSum || 0)}}</div>
                  </div>
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.shipping')}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(productsTableDataTotals.total_order_shipping || 0)}}</div>
                  </div>
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.tips')}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(productsTableDataTotals.total_order_tips || 0)}}</div>
                  </div>
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.totalTax')}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(productsTableDataTotals.total_order_extras || 0)}}</div> -->
                  <!-- </div> -->
                  <!-- VAT Totals by Section -->
                  <template v-if="vatSectionDisplay.length > 0">
                    <div>
                      <!-- Header Row -->
                      <div class="report-row" style="margin-bottom: 8px; font-weight: bold; border-bottom: 1px solid #ddd; padding-bottom: 5px;">
                        <div class="report-col left-align">{{$t('invoice.vatPercent')}} %</div>
                        <div class="report-col right-align">{{$t('reports.fullPrice')}}</div>
                        <div class="report-col right-align">{{$t('reports.orderItemNetPrice')}}</div>
                        <div class="report-col right-align">{{$t('reports.vatAmount')}}</div>
                      </div>
                      <!-- Sections -->
                      <div v-for="section in vatSectionDisplay" :key="section.sectionId" style="margin-top: 15px;">
                        <div class="report-row" style="margin-bottom: 8px;">
                          <div class="report-col left-align" style="font-weight: bold; font-size: 16px;">
                            {{ section.sectionName }}
                          </div>
                        </div>
                        <!-- Data Rows -->
                        <div v-for="(vatRecord, index) in section.records" :key="index" class="report-row" style="margin-bottom: 5px; padding-left: 20px;">
                          <div class="report-col left-align">{{ vatRecord.vat }}%</div>
                          <div class="report-col right-align">{{ vatRecord.total_gross_price_fmt }}</div>
                          <div class="report-col right-align">{{ vatRecord.total_net_price_fmt }}</div>
                          <div class="report-col right-align">{{ vatRecord.total_vat_value_fmt }}</div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <!-- Show "no data" message only when we're not loading -->
                  <template v-else-if="!vatLoading">
                    <div style="margin-top: 20px; text-align: center; color: #909399; padding: 40px 0;">
                      <span style="font-size: 14px;">Nu există date</span>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="card-content total-pagination reports-center-columns master-report-table" style="width: 100%;">
          <data-tables-server
            @query-change="paginationChanged"
            v-loading="loading"
            :data="productsTableData"
            :total="totalOrders"
            :pagination-props="paginationProps"
            :table-props="masterReportTableProps"
            class="master-report-table"
            ref="reportsTable"
          >
            <el-table-column class-name="centered-cell" prop="order_id" :label="$t('reports.orderId')" min-width="100"/>
            <el-table-column class-name="centered-cell" prop="_pos_id_fmt" :label="$t('reports.posId')" min-width="100"/>
            <el-table-column class-name="centered-cell" prop="_item_pos_id_fmt" :label="$t('reports.itemPosId')" min-width="100"/>
            <el-table-column class-name="centered-cell" prop="_menu_item_pos_id_fmt" :label="$t('reports.menuItemPosId')" min-width="100"/>
            <el-table-column class-name="centered-cell" prop="_order_opening_time_fmt" :label="$t('reports.orderCreatedAt')" min-width="160"/>
            <el-table-column class-name="centered-cell" prop="order_number" :label="$t('reports.orderNumber')" min-width="130"/>
            <el-table-column class-name="centered-cell" prop="_table_number_fmt" :label="$t('reports.tableNumber')" min-width="100"/>
            <el-table-column class-name="centered-cell" prop="_product_opening_time_fmt" :label="$t('reports.orderItemCreatedAt')" min-width="160"/>
            <el-table-column class-name="centered-cell" prop="location_name" :label="$t('reports.location')" min-width="120"/>
            <el-table-column class-name="centered-cell" prop="_product_marking_time_fmt" :label="$t('reports.orderItemMarkingTime')" min-width="160"/>
            <el-table-column class-name="centered-cell" prop="_row_type_fmt" :label="$t('reports.type')" min-width="150"/>
            <el-table-column class-name="centered-cell" prop="_top_category_fmt" :label="$t('reports.topCategory')" min-width="130"/>
            <el-table-column class-name="centered-cell" prop="category" :label="$t('reports.category')" min-width="130"/>
            <el-table-column class-name="centered-cell" prop="_product_name_fmt" :label="$t('reports.product')" min-width="150"/>
            <el-table-column class-name="centered-cell" prop="_is_storno_fmt" :label="$t('reports.operation')" min-width="90"/>
            <el-table-column class-name="centered-cell" prop="_operator_name_fmt" :label="$t('reports.operator')" min-width="140"/>
            <el-table-column class-name="centered-cell" prop="_section_name_fmt" :label="$t('reports.section')" min-width="120"/>

            <el-table-column class-name="centered-cell" prop="_gross_price_fmt" min-width="140" :render-header="renderGrossPriceHeader"/>
            <el-table-column class-name="centered-cell" prop="_product_quantity_fmt" min-width="120" :render-header="renderQuantityHeader"/>
            <el-table-column class-name="centered-cell" prop="_product_quantity_quantitative_fmt" :label="$t('reports.quantityUnit')" min-width="120"/>
            <el-table-column class-name="centered-cell" prop="_product_discount_fmt" min-width="150" :render-header="renderProductDiscountHeader"/>
            <el-table-column class-name="centered-cell" prop="_order_discount_fmt" min-width="150" :render-header="renderOrderDiscountHeader"/>
            <el-table-column class-name="centered-cell" prop="_order_loyalty_points_discount_fmt" min-width="180" :render-header="renderOrderLoyaltyDiscountHeader"/>
            <el-table-column class-name="centered-cell" prop="_order_extras_fmt" min-width="180" :render-header="renderOrderExtrasHeader"/>
            <el-table-column class-name="centered-cell" prop="_order_shipping_fmt" min-width="100" :render-header="renderOrderShippingHeader"/>
            <el-table-column class-name="centered-cell" prop="_order_tips_fmt" min-width="100" :render-header="renderOrderTipsHeader"/>
            <el-table-column class-name="centered-cell" prop="_collected_fmt" min-width="140" :render-header="renderCollectedHeader"/>
            <el-table-column class-name="centered-cell" prop="_vat_rate_fmt" :label="$t('invoice.vatPercent')" min-width="90"/>
            <el-table-column class-name="centered-cell" prop="_vat_value_fmt" min-width="120" :render-header="renderVatValueHeader"/>
            <el-table-column class-name="centered-cell" prop="_price_excluding_vat_fmt" min-width="120" :render-header="renderPriceExcludingVatHeader"/>

            <el-table-column class-name="centered-cell" prop="_payment_method_fmt" :label="$t('reports.paymentMethod')" min-width="140"/>
            <el-table-column class-name="centered-cell" prop="_is_fiscalized_fmt" :label="$t('reports.fiscalization')" min-width="110"/>
            <el-table-column class-name="centered-cell" prop="_room_number_fmt" :label="$t('reports.roomNumber')" min-width="100"/>
            <el-table-column class-name="centered-cell" prop="_event_folio_id_fmt" :label="$t('reports.folioId')" min-width="130"/>
            <el-table-column class-name="centered-cell" prop="order_comments" :label="$t('reports.orderComments')" min-width="160"/>
            <el-table-column class-name="centered-cell" prop="product_comments" :label="$t('reports.productComments')" min-width="160"/>
          </data-tables-server>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import {DatePicker} from 'element-ui'
import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
import ChartBarsCard from 'src/components/UIComponents/Cards/ChartBarsCard.vue'
import ChartPieCard from 'src/components/UIComponents/Cards/ChartPieCard.vue'
import moment from 'moment'
import swal from 'sweetalert2'
// import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)

export default {
  components: {
    // GeneralTopBar,
    [DatePicker.name]: DatePicker,
    ChartCard,
    ChartBarsCard,
    ChartPieCard
  },
  props: {
    isMasterReport: {
      type: Boolean,
      default: false
    },
    useFromColumns: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isMasterReport () {
      if (this.isMasterReport) {
        this.getTopCategories()
        this.getPaymentMethods()
        this.getSections()
        this.getOrders(null, { fetchVat: true })
        this.verifyUserLocations()
        this.verifyUserMethods()
        this.timezone = this.$session.get('selectedCompanyData').timezone || 'Europe/Bucharest'
        this._companyTimezoneFormatter = null
        this.getPosUsers()
      }
    }
  },
  // created () {
  //   this.getTopCategories()
  //   this.getPaymentMethods()
  //   this.getOrders()
  //   this.verifyUserLocations()
  //   this.verifyUserMethods()
  //   this.timezone = this.$session.get('selectedCompanyData').timezone || 'Europe/Bucharest'
  //   this.getPosUsers()
  // },
  data () {
    return {
      valid_from: '05:00',
      valid_to: '05:00',
      productsTableData: [],
      posUsers: [],
      selectedPosUser: null,
      timezone: null,
      productsTableDataTotals: {},
      paymentMethods: [],
      orderId: null,
      zet: null,
      receiptOptions: [
        { label: this.$t('reports.withoutReceipt'), value: 1 },
        { label: this.$t('reports.withReceipt'), value: 2 }
      ],
      selectedDriver: '',
      selected_user: '',
      selected_order_from: '',
      selected_payment_methods: [],
      loading: true,
      vatLoading: false,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      orders: {
        'valid': [
          moment().subtract(1, 'day').format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD')
        ],
        location: '',
        method: '',
        search: ''
      },
      date_column: 'created_at',
      locations: [],
      showLocations: false,
      methods: [],
      showMethods: false,
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      pickerNames: ['date_from', 'date_to'],
      ordersTableData: {},
      totalOrders: null,
      // use_tips: this.$session.get('tips_use')
      topCategories: [],
      topCategoryId: [],
      sections: [],
      sectionId: [],
      hasRceipt: null,
      noData: false,
      pagination: {
        page: 1,
        pageSize: 20
      },
      totalSum: 0,
      vat_totals_by_section: {},
      vatSectionDisplay: [],
      _companyTimezoneFormatter: null,
      masterReportTableProps: {
        stripe: false,
        highlightCurrentRow: false,
        rowKey: '_rowKey',
        fit: false
      }
    }
  },
  methods: {
    getCompanyTimezoneFormatter () {
      const tz = this.timezone || 'Europe/Bucharest'
      if (!this._companyTimezoneFormatter || this._companyTimezoneFormatter.resolvedOptions().timeZone !== tz) {
        this._companyTimezoneFormatter = new Intl.DateTimeFormat('en-GB', {
          timeZone: tz,
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false
        })
      }
      return this._companyTimezoneFormatter
    },
    formatToCompanyTimezone (utcString) {
      if (!utcString) {
        return '-'
      }
      const date = new Date(utcString + 'Z')
      const parts = this.getCompanyTimezoneFormatter().formatToParts(date)
      let year = ''
      let month = ''
      let day = ''
      let hour = ''
      let minute = ''
      let second = ''
      for (let i = 0; i < parts.length; i++) {
        const part = parts[i]
        switch (part.type) {
          case 'year': year = part.value; break
          case 'month': month = part.value; break
          case 'day': day = part.value; break
          case 'hour': hour = part.value; break
          case 'minute': minute = part.value; break
          case 'second': second = part.value; break
        }
      }
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`
    },
    mapMasterReportRows (rows) {
      if (!rows || !rows.length) {
        return []
      }
      const singleUnit = this.$t('reports.singleUnit')
      const yesLabel = this.$t('general.yes')
      const noLabel = this.$t('general.no')
      return rows.map((row, index) => Object.freeze({
        _rowKey: `${row.order_id}-${index}`,
        order_id: row.order_id,
        order_number: row.order_number,
        location_name: row.location_name,
        category: row.category,
        order_comments: row.order_comments,
        product_comments: row.product_comments,
        _pos_id_fmt: row.pos_id || '-',
        _item_pos_id_fmt: row.item_pos_id || row.option_pos_id || '-',
        _menu_item_pos_id_fmt: row.menu_item_pos_id || row.menu_option_pos_id || '-',
        _order_opening_time_fmt: row.order_opening_time ? this.formatToCompanyTimezone(row.order_opening_time) : '-',
        _table_number_fmt: row.table_number || '-',
        _product_opening_time_fmt: row.product_opening_time ? this.formatToCompanyTimezone(row.product_opening_time) : '-',
        _product_marking_time_fmt: row.product_marking_time ? this.formatToCompanyTimezone(row.product_marking_time) : '-',
        _row_type_fmt: row.row_type ? this.$t('reports.' + row.row_type) : '-',
        _top_category_fmt: row.top_category || '-',
        _product_name_fmt: row.product_name || row.option_name || '-',
        _is_storno_fmt: row.is_storno ? 'Storno' : 'Marcat',
        _operator_name_fmt: row.operator_name || '-',
        _section_name_fmt: row.section_name || '-',
        _gross_price_fmt: this.formatMoneyAmount(Number(row.gross_price)),
        _product_quantity_fmt: row.product_quantity != null ? row.product_quantity : row.option_quantity,
        _product_quantity_quantitative_fmt: row.row_type === 'item'
          ? (row.product_quantity_quantitative || singleUnit)
          : '-',
        _product_discount_fmt: this.formatMoneyAmount(Number(row.product_discount)),
        _order_discount_fmt: this.formatMoneyAmount(Number(row.order_discount)),
        _order_loyalty_points_discount_fmt: this.formatMoneyAmount(Number(row.order_loyalty_points_discount)),
        _order_extras_fmt: this.formatMoneyAmount(Number(row.order_extras)),
        _order_shipping_fmt: this.formatMoneyAmount(Number(row.order_shipping)),
        _order_tips_fmt: this.formatMoneyAmount(Number(row.order_tips)),
        _collected_fmt: this.formatMoneyAmount(Number(row.collected)),
        _vat_rate_fmt: row.vat_rate === 0 || row.vat_rate === '0'
          ? '0%'
          : (row.vat_rate !== null && row.vat_rate !== undefined && row.vat_rate !== '' ? `${row.vat_rate}%` : '-'),
        _vat_value_fmt: this.formatMoneyAmount(Number(row.vat_value)),
        _price_excluding_vat_fmt: this.formatMoneyAmount(Number(row.price_excluding_vat)),
        _payment_method_fmt: this.$t('paymentTypes.' + row.payment_method),
        _is_fiscalized_fmt: row.is_fiscalized ? yesLabel : noLabel,
        _room_number_fmt: row.room_number || '-',
        _event_folio_id_fmt: row.event_folio_id || '-'
      }))
    },
    buildVatSectionDisplay (vatTotalsBySection) {
      if (!vatTotalsBySection) {
        return []
      }
      return Object.keys(vatTotalsBySection).map(sectionId => {
        const parsedId = sectionId === 'null' || sectionId === null ? null : parseInt(sectionId, 10)
        const records = (vatTotalsBySection[sectionId] || []).map(record => ({
          ...record,
          total_gross_price_fmt: this.formatMoneyAmount(record.total_gross_price || 0),
          total_net_price_fmt: this.formatMoneyAmount(record.total_net_price || 0),
          total_vat_value_fmt: this.formatMoneyAmount(record.total_vat_value || 0)
        }))
        return {
          sectionId,
          sectionName: this.getSectionName(parsedId),
          records
        }
      })
    },
    renderGrossPriceHeader (h) {
      return this.renderHeaderWithTotal(h, this.$t('reports.grossPrice'), this.productsTableDataTotals.total_gross_price)
    },
    renderQuantityHeader (h) {
      return this.renderHeaderWithTotal(h, this.$t('reports.quantity'), this.productsTableDataTotals.total_product_quantity)
    },
    renderProductDiscountHeader (h) {
      return this.renderHeaderWithTotal(h, this.$t('reports.orderItemDiscount'), this.productsTableDataTotals.total_product_discount)
    },
    renderOrderDiscountHeader (h) {
      return this.renderHeaderWithTotal(h, this.$t('reports.orderDiscount'), this.productsTableDataTotals.total_order_discount)
    },
    renderOrderLoyaltyDiscountHeader (h) {
      return this.renderHeaderWithTotal(h, this.$t('reports.orderLoyaltyDiscount'), this.productsTableDataTotals.total_order_loyalty_points_discount)
    },
    renderOrderExtrasHeader (h) {
      return this.renderHeaderWithTotal(h, this.$t('reports.tax'), this.productsTableDataTotals.total_order_extras)
    },
    renderOrderShippingHeader (h) {
      return this.renderHeaderWithTotal(h, this.$t('reports.shipping'), this.productsTableDataTotals.total_order_shipping)
    },
    renderOrderTipsHeader (h) {
      return this.renderHeaderWithTotal(h, this.$t('reports.tips'), this.productsTableDataTotals.total_order_tips)
    },
    renderCollectedHeader (h) {
      return this.renderHeaderWithTotal(h, this.$t('reports.orderItemValueCollected'), this.productsTableDataTotals.total_collected)
    },
    renderVatValueHeader (h) {
      return this.renderHeaderWithTotal(h, this.$t('reports.vatAmount'), this.productsTableDataTotals.total_vat_value)
    },
    renderPriceExcludingVatHeader (h) {
      return this.renderHeaderWithTotal(h, this.$t('reports.orderItemNetPrice'), this.productsTableDataTotals.total_price_excluding_vat)
    },
    getPaymentMethods () {
      let sessionData = this.$session.get('selectedCompanyData')

      if (!sessionData['payment_methods']) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }

        this.apiRequest('/orders/get-payment-methods', 'GET', data, (response) => {
          if (response.status && response.data.length) {
            let result = response.data.map(item => {
              return {id: item || 'unpaid', name: this.$t('paymentTypes.' + item)}
            })
            sessionData['payment_methods'] = response.data
            this.$session.set('selectedCompanyData', sessionData)

            Vue.set(this, 'paymentMethods', result)
          }
        })
      } else {
        let result = sessionData['payment_methods'].map(item => {
          return {id: item || 'unpaid', name: this.$t('paymentTypes.' + item)}
        })
        Vue.set(this, 'paymentMethods', result)
      }
    },
    getTopCategories () {
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }

      this.apiRequest('/topcategory', 'GET', data, (response) => {
        if (response.status === true) {
          this.topCategories = response.data
        }
      })
    },
    getSections () {
      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      this.apiRequest('/sections', 'GET', data, (response) => {
        if (response.status === true) {
          this.sections = response.data
        }
      })
    },
    startDownload () {
      this.loading = true
    },
    finishDownload () {
      this.loading = false
    },
    changeValidFrom () {
      // if (this.valid_to <= this.valid_from) {
      //   this.valid_to = '23:59'
      // }
      if (!this.valid_from) {
        this.valid_from = '05:00'
      }
      if (!this.valid_to) {
        this.valid_to = '05:00'
      }
    },
    paginationChanged (query) {
      // Avoid concurrent requests while a load is in progress
      if (this.loading) {
        return
      }
      if (query.type === 'page') this.getOrders(query, { fetchVat: false })
      if (query.type === 'size') this.getOrders(query, { fetchVat: false })
      if (query.type === 'sort') this.getOrders(query, { fetchVat: false })
    },
    verifyUserLocations () {
      this.locations = this.$session.get('selectedCompanyData').locations_details.map(location => ({
        id: location.true_id,
        name: location.name
      }))

      if (!this.isOwner()) {
        let allowedLocations = JSON.parse(this.$session.get('userDataLocations'))

        if (allowedLocations.length === 0) {
          this.showLocations = true
          this.locations.forEach((element) => {
            allowedLocations.push(element.id)
          })
        }

        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id)
        })
      }

      if (this.locations.length > 1) {
        this.showLocations = true
      }

      let filterCookie = this.$cookie.get('filter-locations')
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie)
        this.orders.location = filterCookie[0]
      }
    },
    renderHeaderWithTotal (h, label, total) {
      return h('div', {
        style: {
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          minHeight: '100%',
          textAlign: 'center',
          padding: '4px',
          boxSizing: 'border-box',
          justifyContent: 'space-between',
          overflow: 'visible'
        }
      }, [
        h('div', {
          style: {
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
            hyphens: 'auto',
            whiteSpace: 'normal',
            lineHeight: '1.2',
            minWidth: '0'
          }
        }, label),
        h('div', {
          style: {
            display: 'flex',
            justifyContent: 'center',
            marginTop: '4px'
          }
        }, [
          h('span', {
            style: {
              background: '#674BD2',
              color: '#fff',
              borderRadius: '5px',
              padding: '2px 6px',
              fontWeight: 'bold',
              fontSize: '12px',
              lineHeight: '1',
              whiteSpace: 'nowrap',
              display: 'inline-block'
            }
          }, total)
        ])
      ])
    },
    verifyUserMethods () {
      this.methods = this.$session.get('selectedCompanyData').delivery_options_labels
      this.showMethods = true
    },
    isUnpaidSelected () {
      if (!this.selected_payment_methods || !Array.isArray(this.selected_payment_methods)) {
        return false
      }
      // Handle both string IDs and objects
      return this.selected_payment_methods.some(method => {
        const id = typeof method === 'string' ? method : (method && method.id)
        return id === 'unpaid'
      })
    },
    getPaymentMethodsArray () {
      if (!this.selected_payment_methods || !Array.isArray(this.selected_payment_methods)) {
        return []
      }
      // Extract IDs from array, filter out 'unpaid', and ensure we only have strings
      return this.selected_payment_methods
        .map(method => {
          // If it's already a string, use it; otherwise extract the id
          return typeof method === 'string' ? method : (method && method.id ? method.id : null)
        })
        .filter(method => method && method !== 'unpaid') // Remove null/undefined and 'unpaid'
    },
    getOrders (query, { fetchVat = false } = {}) {
      if (!this.isMasterReport) {
        return
      }
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59'
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59'
      }

      let fromDate = this.orders.valid[0] + ' ' + this.valid_from
      let toDate = this.orders.valid[1] + ' ' + this.valid_to

      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate,
        date_column: this.date_column,
        order_id: this.orderId,
        selected_payment_methods: this.getPaymentMethodsArray(),
        unpaid_orders: this.isUnpaidSelected() ? 1 : 0,
        operator: this.selectedPosUser,
        zet: this.zet
      }

      if (this.topCategoryId) {
        const result = this.topCategoryId.map(elem => {
          return elem.id
        })
        data.top_category_id = result
      }

      if (this.sectionId) {
        const result = this.sectionId.map(elem => {
          return elem.id
        })
        data.section_id = result
      }

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location
      }

      this.loading = true
      if (fetchVat) {
        this.vatLoading = true
      }
      const pageSize = query ? query.pageSize : 20
      const page = query ? query.page : 1
      const hasReceiptValue = (this.hasRceipt && this.hasRceipt.value) || null

      const masterEndpoint = this.useFromColumns
        ? '/reports/v2/master-report-from-columns'
        : '/reports/v2/master-report'
      const masterUrl = masterEndpoint + '?page=' + page + '&perPage=' + pageSize + '&has_receipt=' + hasReceiptValue

      this.apiRequest(masterUrl, 'GET', data, response => {
        const masterSuccess = !!(response && response.status)
        if (masterSuccess) {
          try {
            this.productsTableData = this.mapMasterReportRows(response.data)
            const pag = response.pagination || {}
            this.totalOrders = pag.total
            this.paginationProps.currentPage = pag.page
            this.paginationProps.pageSize = pag.perPage
            this.productsTableDataTotals = response.totals || {}

            const apiTotal =
              (response.card_totals && response.card_totals.total_amount) ||
              response.total_gross_price

            if (apiTotal !== undefined && apiTotal !== null) {
              this.totalSum = parseFloat(apiTotal) || 0
            } else {
              const t = this.productsTableDataTotals
              this.totalSum =
                Number(t.total_collected || 0) +
                Number(t.total_order_shipping || 0) +
                Number(t.total_order_tips || 0) -
                Number(t.total_order_discount || 0) -
                Number(t.total_order_loyalty_points_discount || 0)
            }
          } catch (e) {
            swal(
              '',
              this.$t('validations.wentWrong'),
              'error'
            )
          }
        } else {
          swal(
            '',
            (response && response.errors && response.errors['id']) ? response.errors['id'] : this.$t('validations.wentWrong'),
            'error'
          )
        }
        this.$nextTick(() => {
          this.loading = false
          this.syncMasterReportTableLayout()
        })
      })

      if (fetchVat) {
        this.apiRequest('/reports/v2/master-report-vat-totals-by-section', 'GET', data, vatResponse => {
          if (vatResponse && vatResponse.status) {
            this.vat_totals_by_section =
              vatResponse.vat_totals_by_section ||
              vatResponse.data ||
              {}
            this.vatSectionDisplay = this.buildVatSectionDisplay(this.vat_totals_by_section)
          } else {
            this.vat_totals_by_section = {}
            this.vatSectionDisplay = []
          }
          this.$nextTick(() => {
            this.vatLoading = false
          })
        })
      }
    },
    updateData () {
      // Prevent triggering a new search while a request is in progress
      if (this.loading) {
        return
      }
      this.getOrders(null, { fetchVat: true })
      this.$cookie.set('filter-locations', JSON.stringify([this.orders.location]), 30)
    },
    currentDate () {
      return moment().format('DD-MM-YYYY') + '.xls'
    },
    exportData () {
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59'
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59'
      }

      let fromDate = this.orders.valid[0] + ' ' + this.valid_from
      let toDate = this.orders.valid[1] + ' ' + this.valid_to

      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate,
        date_column: this.date_column,
        order_id: this.orderId,
        selected_payment_methods: this.getPaymentMethodsArray(),
        unpaid_orders: this.isUnpaidSelected() ? 1 : 0,
        operator: this.selectedPosUser,
        pageSize: this.paginationProps.pageSize,
        page: this.paginationProps.currentPage,
        has_receipt: (this.hasRceipt && this.hasRceipt.value) || null,
        zet: this.zet
      }

      if (this.topCategoryId) {
        const result = this.topCategoryId.map(elem => {
          return elem.id
        })
        data.top_category_id = result
      }

      if (this.sectionId) {
        const result = this.sectionId.map(elem => {
          return elem.id
        })
        data.section_id = result
      }

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location
      }

      this.loading = true
      const downloadEndpoint = this.useFromColumns
        ? '/reports/v2/master-report-from-columns-download'
        : '/reports/v2/master-report-download'
      this.apiRequest(downloadEndpoint, 'GET', data, response => {
        if (response.status === true) {
          const link = document.createElement('a')
          link.href = response.data.file
          link.setAttribute('download', response.data.file_name)
          document.body.appendChild(link)
          link.click()
        } else {
          swal(
            '',
            this.$t('validations.wentWrong'),
            'error'
          )
        }
        this.loading = false
      })
    },
    exportVatTotalsPdf () {
      if (this.loading) {
        return
      }
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59'
      }
      if (this.valid_from === '24:00') {
        this.valid_from = '23:59'
      }

      const fromDate = this.orders.valid[0] + ' ' + this.valid_from
      const toDate = this.orders.valid[1] + ' ' + this.valid_to

      const params = new URLSearchParams()
      params.append('token', this.$session.get('token'))
      params.append('company_id', this.$session.get('selectedCompany'))
      params.append('lang', this.$i18n.locale || 'ro')
      params.append('from_date', fromDate)
      params.append('to_date', toDate)
      params.append('date_column', this.date_column)
      if (this.orderId) params.append('order_id', this.orderId)
      if (this.zet) params.append('zet', this.zet)
      params.append('unpaid_orders', this.isUnpaidSelected() ? 1 : 0)
      const hasReceipt = (this.hasRceipt && this.hasRceipt.value) || null
      if (hasReceipt != null) params.append('has_receipt', hasReceipt)

      const paymentMethods = this.getPaymentMethodsArray()
      paymentMethods.forEach(id => params.append('selected_payment_methods', id))

      if (this.topCategoryId && this.topCategoryId.length) {
        this.topCategoryId.forEach(elem => params.append('top_category_id', elem.id))
      }
      if (this.sectionId && this.sectionId.length) {
        this.sectionId.forEach(elem => params.append('section_id', elem.id))
      }
      if (this.orders.location && this.orders.location !== '') {
        params.append('location_id', this.orders.location)
      }

      const baseUrl = process.env.API_BASE_URL.replace(/\/$/, '')
      const url = `${baseUrl}/reports/v2/vat-totals-pdf?${params.toString()}`

      window.open(url, '_blank')
    },
    getPosUsers () {
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }

      this.apiRequest('/pos/all/users', 'GET', data, (response) => {
        if (response.status) {
          this.posUsers = response.data.pos_user
        }
      })
    },
    getSectionName (sectionId) {
      if (sectionId === null || isNaN(sectionId)) {
        return this.$t('general.unset')
      }
      const section = this.sections.find(s => s.id === sectionId)
      return section ? section.name : `Section ${sectionId}`
    },
    syncMasterReportTableLayout () {
      this.$nextTick(() => {
        const table = this.$refs.reportsTable && this.$refs.reportsTable.$refs.elTable
        if (!table || typeof table.doLayout !== 'function') {
          return
        }
        table.doLayout()
        requestAnimationFrame(() => {
          table.doLayout()
        })
      })
    }
  }
}
</script>
<style>
  .ct-label {
    display: none;
  }
  .ct-legend-inside .inactive {
    opacity: 0.3;
  }
  .cell b {
    word-break: break-word;
  }
  .card .details h6 {
    text-align: left;
    font-weight: 500;
  }
  .report-container {
    display: flex;
    flex-direction: column;
    background: #FBFCFF;
    border-radius: 11px;
    padding: 70px;
  }
  .report-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 25px;
  }
  .sales-report .sales-height .card {
    min-height: 500px;
    display: flex;
    justify-content: center;
  }
  .sales-report .sales-height:nth-child(1) .card {
    align-items: center;
  }
  .center-sales-report-stats .card-content{
    max-width: 800px;
    width: 650px;
  }
  .report-col {
    flex: 1;
    padding: 0 10px;
  }
  .report-col:nth-child(1){
    color: #25396F;
    font-size: 18px;
    font-weight: 500;
  }
  /* .ct-label.ct-horizontal {
    white-space: pre-line;
    text-anchor: middle;
    font-size: 12px;
  } */
  .ct-label.ct-horizontal {
    font-size: 12px !important;
    text-anchor: middle !important;
  }
  foreignObject div {
    font-size: 12px;
    line-height: 1.2em;
    text-align: center;
    color: #333;
  }

  .ct-label .ct-vertical {
    font-size: 12px;
    overflow: visible !important;
  }

  /* .ct-chart {
    overflow: visible !important;
  } */

  .ct-chart {
    padding-top: 20px; /* or more */
    overflow: visible !important;
  }

  /* Headers: flex for label + total badge alignment */
  .master-report-table .el-table__header-wrapper .centered-cell .cell {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center !important;
    white-space: normal;
    line-height: 1.4;
  }

  /* Body: no flex — much cheaper to scroll */
  .master-report-table .el-table__body-wrapper td.centered-cell {
    text-align: center;
  }

  .master-report-table .el-table__body-wrapper .centered-cell .cell {
    display: block;
    width: 100%;
    text-align: center !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* Global row hover repaint is expensive on wide tables */
  .master-report-table .el-table__body tr:hover > td,
  .master-report-table .el-table__body tr:hover > td .cell {
    background-color: inherit !important;
    transition: none !important;
  }

  .el-table th .cell {
    white-space: normal;
    line-height: 1.4;
  }

  .report-container {
    display: flex;
    flex-direction: column;
    background: #FBFCFF;
    border-radius: 11px;
    padding: 15px !important;
  }
  .report-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
  }
  .center-sales-report-stats .card-content{
    max-width: 800px;
    width: 100% !important;
    height: 100% !important;
  }
  .report-col {
    flex: 1;
    padding: 0 10px;
  }
  .report-col:nth-child(1){
    color: #25396F;
    font-size: 18px;
    font-weight: 500;
  }
  .left-align {
    text-align: left;
  }
  .right-align {
    text-align: right;
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/Versions/2/MasterReport.vue